<template>
    <div class="customer-biodata mt-3">
        <b-card no-body v-if="!is_loading && current_customer">
            <b-card-header class="border-0" :class="current_customer.cjp_id ? 'px-3 py-0': 'p-3'">
                <b-row align-v="center">
                    <b-col cols="12" class="text-center mb-3" v-if="$route.query.joint_profile">
                        <a href="javascript:void(0)" class="font-weight-bold d-flex align-items-center" @click="backToJointProfile">
                            <b-icon icon="caret-left-fill"></b-icon>
                            Back to Joint Profile
                        </a>
                    </b-col>
                    <b-col cols="12" v-if="current_customer.cjp_id" class="p-0">
                        <div style="background-color: #394A64;" class="py-2 px-3 rounded-top">
                            <h3 class="mb-0 text-white text-center">
                                <b-icon icon="people-fill" class="mr-2"></b-icon>Joint Profile
                            </h3>
                        </div>
                        <div class="p-3">
                            <div v-for="(joint_profile, index) in current_customer.customer_joint_profiles" :key="index" class="mb-2">
                                <div class="d-flex align-items-center">
                                    <b-iconstack font-scale="1.8">
                                        <b-icon stacked icon="square-fill" 
                                            v-b-tooltip.hover="checkIsCorporateSubscription() ? 
                                                BASKET_DESCRIPTION[joint_profile.basket.basket_color] : 
                                                ''
                                            "  
                                            :style="{'color':BASKET_COLOR[joint_profile.basket.basket_color]}"></b-icon>
                                        <b-icon stacked icon="basket2" scale="0.5" class="text-white"></b-icon>
                                    </b-iconstack>
                                    <h4 class="ml-3 mb-0 text-capitalize text-primary">
                                        <router-link :to="'/customerProfileDetails/'+joint_profile.customer_id+'?joint_profile='+current_customer.customer_id+'&active=overview'">
                                            {{ joint_profile.name }} ({{  checkAppCode('vps') ? joint_profile.masked_id : joint_profile.customer_id }})
                                        </router-link>
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <b-col cols="10" v-if="!current_customer.cjp_id">
                        <h3 class="mb-0">
                            {{current_customer.name | formatUserName }}
                        </h3>
                    </b-col>
                    <b-col cols="2" v-if="!current_customer.cjp_id">
                        <el-button @click="$refs.drawer_edit_profile.viewEditProfile()" class="float-right py-0 text-primary" type="text">Edit</el-button>
                    </b-col>
                </b-row>
            </b-card-header>
            <b-container>
                <b-row class="align-items-center status mb-3">
                    <b-col cols="6" class="pr-1">
                        <div class="border rounded p-2">
                            <span class="mb-0 text-muted">Main Status</span><br>
                            <el-select
                                v-model="main_status_id"
                                value-key="status_id"
                                filterable
                                size="mini"
								:disabled="_gAuth.isAppSas()"
																@change="_gNotif.notifySuccess('<b>Please select the sub status also')"
															  ><el-option

                                v-for="status in main_statuses"
                                :key="status.status_id"
                                :label="status.status"
                                :value="status.status_id"
                                >
                                </el-option>
                            </el-select>
                        </div>
                    </b-col>
                    <b-col cols="6" class="pl-1">
                        <div class="border rounded p-2">
                            <span class="mb-0 text-muted">Sub Status</span><br>
                            <el-select
                                v-model="sub_status_id"
                                value-key="status_id"
                                filterable
                                size="mini"
                                @change="updateStatus($event)"
                                ><el-option
                                v-for="status in sub_statuses"
                                :key="status.status_id"
                                :label="status.status"
                                :value="status.status_id"
                                >
                                </el-option>
                            </el-select>
                        </div>
                    </b-col>
                </b-row>
                <b-row class="align-items-center status mb-3" v-if="_gAuth.isAppSas() && !isEmpty(current_customer.send_to_advisory)" >
            <b-col cols="8" class="pl-3">
                <div class="border rounded p-2">
                    <span class="mb-0 text-muted">Advisory Status</span><br>
                    <el-select
                        v-model="advisory_status_id"
                        value-key="status_id"
                        filterable
                        size="mini"
                    >
                        <el-option
                            v-for="status in loanAdvisorySubStatusList"
                            :key="status.status_id"
                            :label="status.status"
                            :value="status.status_id"
                            @click.native="updateCustomerAdvisoryStatus(current_customer.customer_id, status.status_id)"
                        >
                        </el-option>
                    </el-select>
                </div>
            </b-col>
        </b-row>

                <b-row class="px-3 mb-2 flex-wrap" align-v="center" v-if="!current_customer.cjp_id">
                    <b-col cols="auto"  class="d-flex align-items-center justify-content-between border rounded px-2 py-1 my-1" v-loading="loading_dsr">
                        <div class="mr-3">
                            <p class="text-xs">DSR</p>
                            <p class="text-muted">{{current_customer.incomes.main.dsr || 'N/A'}}</p>
                        </div>
                        <a href="javascript:void(0)" @click="refreshDSR">
                            <b-iconstack font-scale="2.5">
                                <b-icon stacked icon="square-fill" 
                                    v-b-popover.hover.html="basketCausePopover"
                                    :style="{'color': basketCardColor }"></b-icon>
                                <b-icon stacked icon="basket2" scale="0.5" class="text-white"></b-icon>
                            </b-iconstack>
                        </a>
                    </b-col>
                    <b-col cols="auto" class="my-1"  v-if="auth_user.subscription.privileges.scpk_crm_chat_massage">
                        <b-row>
                            <MessagingBoxButton :type="'customer'" :profile="current_customer" />		
                            <el-button class="p-1 ml-2" type="primary"
                                @click="showSms(current_customer)" >
                                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="20" viewBox="0 0 512 512"><path fill="#FFFFFF" d="M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zM96 212.8c0-20.3 16.5-36.8 36.8-36.8H152c8.8 0 16 7.2 16 16s-7.2 16-16 16h-19.2c-2.7 0-4.8 2.2-4.8 4.8 0 1.6.8 3.1 2.2 4l29.4 19.6c10.3 6.8 16.4 18.3 16.4 30.7 0 20.3-16.5 36.8-36.8 36.8H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h27.2c2.7 0 4.8-2.2 4.8-4.8 0-1.6-.8-3.1-2.2-4l-29.4-19.6c-10.2-6.8-16.4-18.3-16.4-30.7M372.8 176H392c8.8 0 16 7.2 16 16s-7.2 16-16 16h-19.2c-2.7 0-4.8 2.2-4.8 4.8 0 1.6.8 3.1 2.2 4l29.4 19.6c10.2 6.8 16.4 18.3 16.4 30.7 0 20.3-16.5 36.8-36.8 36.8H352c-8.8 0-16-7.2-16-16s7.2-16 16-16h27.2c2.7 0 4.8-2.2 4.8-4.8 0-1.6-.8-3.1-2.2-4l-29.4-19.6c-10.2-6.8-16.4-18.3-16.4-30.7 0-20.3 16.5-36.8 36.8-36.8m-152 6.4 35.2 46.9 35.2-46.9c4.1-5.5 11.3-7.8 17.9-5.6S320 185.1 320 192v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48l-19.2 25.6c-3 4-7.8 6.4-12.8 6.4s-9.8-2.4-12.8-6.4L224 240v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-6.9 4.4-13 10.9-15.2s13.7.1 17.9 5.6"/></svg>
                            </el-button>
                        </b-row>
                    </b-col>
                    <b-col cols="12" class="my-1 ml-auto px-0" v-if="!current_customer.cjp_id">
                        <b-button block class="px-2 py-1 d-flex align-items-center justify-content-between" variant="primary" @click="$refs.drawer_buy_fintscore.viewDetails()">
                            <span class="text-left">
															<strong class="d-block">Prescreening Analysis</strong> 
															<small v-if="current_commitment">Latest report: {{ current_commitment.credit_report_response_datetime | dateTimeFormatString }}</small>
                            	<small v-else>Latest Report: No Purchase</small>
														</span>
                            <b-icon icon="caret-right-fill"></b-icon>
                        </b-button>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group cols="12" md="6" class="mb-2 mt-2">
                            <el-date-picker v-model="current_customer.appointment_at" type="datetime" format="yyyy-MM-dd HH:mm:ss"
                                value-format="yyyy-MM-dd HH:mm:ss"  placeholder="Select appointment time and date" 
                                @change="submitAppointment">
                            </el-date-picker>
                        </b-form-group>
                            <b-button block variant="outline-primary" v-if="!isEmpty(current_customer.appointment_at)"
                                    @click="exportToGoogleCalendar(current_customer.appointment_at, current_customer.name)" 
                                    class="el-icon-date"
                                    style="cursor: pointer;">
                                    Export Appointment to Calendar
                            </b-button>
                    </b-col>
                </b-row>
                <b-row class="my-3"  v-if="!current_customer.cjp_id">    
                    <b-col cols="12">
                        <div class="d-flex align-items-center mb-2">
                            <small class="pr-3 font-weight-bolder text-gray">ID</small>
                            <p>{{checkAppCode('vps') ? current_customer.masked_id : current_customer.customer_id}}</p>
                        </div>
                        <div class="d-flex align-items-center mb-2">
                            <b-icon icon="person-fill" class="mr-3" variant="gray"></b-icon>
                            <p>{{ current_customer.age ? current_customer.age + ' Years Old' : 'N/A' }}</p>
                        </div>
                        <div class="d-flex align-items-center mb-2" v-if="current_customer.dob">
                            <b-icon icon="calendar-date-fill" class="mr-3" variant="gray"></b-icon>
                            <p>{{ current_customer.dob }}</p>
                        </div>
                        <div class="d-flex align-items-center mb-2" v-if="current_customer.passport && current_customer.is_foreigner === 1">
                            <b-icon icon="person-badge-fill" class="mr-3" variant="gray"></b-icon>
                            <p>{{ current_customer.passport}}</p>
                        </div>
                        <div class="d-flex align-items-center mb-2" v-if="current_customer.nric && current_customer.is_foreigner === 0">
                            <b-icon icon="person-badge-fill" class="mr-3" variant="gray"></b-icon>
                            <p>{{ current_customer.nric | formatNRIC}}</p>
                        </div>
                        <div class="d-flex align-items-center mb-2">
                            <b-icon icon="telephone-fill" class="mr-3" variant="gray"></b-icon>
                            <p>{{ current_customer.contact_no || 'N/A' }}</p>
                        </div>
                        <div class="d-flex align-items-center mb-2">
                            <b-icon icon="building" class="mr-3" variant="gray"></b-icon>
                            <p>{{ current_customer.companies.current ? current_customer.companies.current.name : 'N/A' }}</p>
                        </div>
                        <div class="d-flex align-items-center mb-2">
                            <b-icon icon="briefcase-fill" class="mr-3" variant="gray"></b-icon>
                            <p>{{ current_customer.companies.current ? current_customer.companies.current.position : 'N/A' }}</p>
                        </div>
                        <div class="d-flex align-items-center mb-2">
                            <b-icon icon="layers" class="mr-3" variant="gray"></b-icon>
                            <p>{{ current_customer.companies.current ? current_customer.companies.current.company_type : 'N/A' }}</p>
                        </div>

												<hr/>
                        <div class="d-flex align-items-center mb-2" v-if="_gAuth.isAppSas() && !current_customer.cjp_id">
                            <!-- <b-icon class="mr-3" variant="gray"></b-icon> -->
														<i class="fa fa-boxes mr-3"></i>
														<p>
															Channel: {{ customerChannel }}
														</p>
                        </div>
                        <div class="d-flex align-items-center justify-content-start mb-2 text-success" v-if="_gAuth.isAppSas() && !current_customer.cjp_id">
													<template v-if="!_gHlp.isEmpty(app_form_esign_link)">
														<i class="fab fa-whatsapp mr-3"></i>
                            <p class="text-success" style="line-height: 12pt;">
															<a href="javascript:void(0)" @click="sendToWhatsApp(app_form_esign_link)">Send Engagement Form Link</a><br/>
															<small class="text-danger">{{ app_form_expired_date }} <u class="text-danger" v-if="app_form_can_generate" @click="generateAppFormLink()">Re-Generate</u></small>
                            </p>
														<span class="ml-auto">
															<a v-if="!_gHlp.isEmpty(app_form_esign_down_link)" :href="app_form_esign_down_link" download><i class="fa fa-download mx-1 text-primary" style="cursor: pointer"></i></a>
															<i class="far fa-copy mx-1" style="cursor: pointer" @click="copyApplicationFormLink(app_form_esign_link)"></i>
														</span>
													</template>
													<template v-else>
														<i class="fa fa-sync mr-3 text-danger"></i>
                            <p class="text-danger">
															<a href="javascript:void(0)" class="text-danger" @click="generateAppFormLink()">Generate Engagement Form Link</a>
                            </p>
													</template>
                        </div>
                        <div class="d-flex align-items-center mb-2 text-success" v-if="_gAuth.isAppSas()">
                            <i class="fab fa-whatsapp mr-3"></i>
                            <p class="text-success">
                                <a href="javascript:void(0)" @click="sendGoogleReviewLink(current_customer.contact_no)">Send Google Review Link</a>
                            </p>
														<span class="ml-auto">
															<i class="far fa-copy mx-1" style="cursor: pointer" @click="copyGoogleReviewLink()"></i>
														</span>
                        </div>

												<!-- <div class="d-flex align-items-center mb-2">
                            <b-icon icon="briefcase-fill" class="mr-3" variant="gray"></b-icon>
                            <p><strong>Category:</strong> {{current_customer.category || 'N/A' }}</p>
                        </div> -->
                    </b-col>
                </b-row>
            </b-container>
        </b-card>
        <b-card no-body v-else v-loading="is_loading">
            <div class="bg-light p-5 text-center rounded">
            </div>
        </b-card>

        <!-- Drawer for Edit Profile -->
        <drawer-edit-profile ref="drawer_edit_profile"></drawer-edit-profile>

        <!-- Drawer for Net Income Details -->
        <drawer-buy-fintscore-report ref="drawer_buy_fintscore"></drawer-buy-fintscore-report>

            </div>
</template>
<script>
import { Tag, Card, Button, DatePicker, Select, Option } from 'element-ui'
import DrawerEditProfile from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerEditProfile/DrawerEditProfile'
import DrawerBuyFintscoreReport from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerFintscoreReport/DrawerFintscoreReport'
import notifyFunctionMixin from '@/assets/js/notifyFunctionMixin'
import { mapActions, mapState } from 'pinia'
import { useCustomerStore } from '@/stores/customerStore'
import {BASKET_COLOR} from '@/assets/js/colors.js'
import MessagingBoxButton from '@/views/Messaging/MessagingBoxButton'
import { useMessagingStore } from '@/stores/messagingStore'
import {
        axios,
        services,
        getHeader,
        helperFunctionMixin
    } from '@/assets/js/httpImports.js'
import { useAuthStore } from '@/stores/authStore'
import {BASKET_DESCRIPTION} from '@/assets/js/status.js'
import { fintosCustomerFormLink } from '@/assets/js/config.js'
import chatEventBus from '@/assets/js/EventBus/chatEventBus.js'
import { useNotificationStore } from '@/stores/notificationStore'


    export default {
        name: 'customer-biodata',
        props: ['corporateList'],
        mixins: [notifyFunctionMixin, helperFunctionMixin],
        components: {
            DrawerEditProfile,
            DrawerBuyFintscoreReport,
            MessagingBoxButton,
            [Tag.name]: Tag,
            [Card.name]: Card,
            [Button.name]: Button,
            [Select.name]: Select,
            [Option.name]: Option,
            [DatePicker.name]: DatePicker,

        },
        data(){
            return{
                BASKET_DESCRIPTION:BASKET_DESCRIPTION,
                BASKET_COLOR:BASKET_COLOR,
                main_status_id: null,
                sub_status_id: null,
                advisory_status_id: null,
                is_loading:false,
                loanAdvisorySubStatusList:[],
                dsrflg: false,
            }
        },
        computed: {
            ...mapState(useAuthStore,['auth_user']),
            ...mapState(useCustomerStore,['current_customer', 'current_commitment', 'loading_dsr','customer_statuses', 'app_form_esign_link','app_form_esign_down_link','app_form_can_generate','app_form_expired_date']),
            ...mapState(useMessagingStore,['sms_template_list']),
            main_statuses(){
                return !_gHlp.isEmpty(this.customer_statuses) ? this.customer_statuses.filter(data => data.group === "main") : [];
            },
						sub_statuses(){
							let allSubStatuses = !_gHlp.isEmpty(this.customer_statuses) ? this.customer_statuses.filter(data => data.group === "sub") : [];
							let main_status_id = this.main_status_id;
							// return (!_gHlp.isEmpty(main_status_id)) ? allSubStatuses.filter(data => data.parent_id == main_status_id) : allSubStatuses;
							return allSubStatuses
						},
            customerChannel() {
                return this.current_customer.channel?.name ?? this.getAltChannel(this.current_customer.application_code);
            },
            hasMonthInstArrearsOver3() {
                const commitments = this.current_commitment?.credit_report_summary?.commitments || []
                for (const item of commitments) {
                    const monthly = Array.isArray(item.commitment_monthly) ? item.commitment_monthly : (item.commitment_monthly ? [item.commitment_monthly] : [])
                    for (const m of monthly) {
                        const val = parseFloat(m && m.month_inst_arrears)
                        if (!Number.isNaN(val) && val >= 3) return true
                    }
                    const subItems = item.commitment_sub_items || []
                    for (const sub of subItems) {
                        const subMonthly = Array.isArray(sub.commitment_monthly) ? sub.commitment_monthly : (sub.commitment_monthly ? [sub.commitment_monthly] : [])
                        for (const m of subMonthly) {
                            const val = parseFloat(m && m.month_inst_arrears)
                            if (!Number.isNaN(val) && val >= 3) return true
                        }
                    }
                }
                return false
            },
            basketCardColor() {
                if (!this.current_customer?.basket?.basket_raw_json?.basket_json) {
                    return this.BASKET_COLOR[this.current_customer?.basket?.basket_color] || ''
                }

                const rawList = this.current_customer.basket.basket_raw_json.basket_json
                let causes = rawList
                    .filter(item => item.stage_risk > 1)
                    .sort((a, b) => b.stage_risk - a.stage_risk)

                const hasPtpTnLatePayments = causes.some(itm =>
                    (itm.stage_title || '').toLowerCase().includes('ptptn') &&
                    (itm.stage_title || '').toLowerCase().includes('late')
                )

                causes = causes.filter(itm => {
                    const title = (itm.stage_title || '').toLowerCase()
                    const isLapse = title.includes('lapse')
                    if (isLapse) {
                        if (hasPtpTnLatePayments) return false
                        return this.hasMonthInstArrearsOver3
                    }
                    return true
                })

                if (causes.length > 0 && causes[0].stage_color) {
                    const firstColor = causes[0].stage_color || ''
                    const colorKey = firstColor.charAt(0).toUpperCase() + firstColor.slice(1).toLowerCase()
                    return this.BASKET_COLOR[colorKey] || firstColor || ''
                }

                return this.BASKET_COLOR[this.current_customer?.basket?.basket_color] || ''
            },
            basketCausePopover() {
                if (!this.current_customer?.basket?.basket_raw_json?.basket_json) return "<b>Congratulations!</b> Your screening is successful. You're qualified for loan application and we will help you proceed instantly. Please prepare your documents - we'll guide you next."
                const baket_json = this.current_customer.basket.basket_raw_json.basket_json
                let causes = baket_json.filter(item => item.stage_risk > 1).sort((a, b) => b.stage_risk - a.stage_risk)
                const hasPtpTnLatePayments = causes.some(itm => (itm.stage_title || '').toLowerCase().includes('ptptn') && (itm.stage_title || '').toLowerCase().includes('late'))
                causes = causes.filter(itm => {
                    const title = (itm.stage_title || '').toLowerCase()
                    const isLapse = title.includes('lapse')
                    if (isLapse) {
                        if (hasPtpTnLatePayments) return false
                        return this.hasMonthInstArrearsOver3
                    }
                    return true
                })
                let text = ''
                for (const key in causes) {
                    const element = causes[key]
                    text += "<dt><i class='fa fa-circle' style='color:"+element.stage_color+"'></i> "+element.stage_title+"</dt><dd><small>"+element.stage_input_technical+"</small></dd>"
                }
                return (text !== '') ? "<dl>"+text+"</dl>" : "<b>Congratulations!</b> Your screening is successful. You're qualified for loan application and we will help you proceed instantly. Please prepare your documents - we'll guide you next."
            },
        },
        watch:{
            '$route.params.customer_id':{
                handler(newVal){
                    if(newVal){
                        this.getCustomerDetails()
                    }
                }
            },
            current_customer:{
                handler(newVal){
                    if(!this.dsrflg) {
                        this.dsrflg = true;
                        this.generateDSR();
                    } else {
                        this.dsrflg = false;
                    }
                    this.getProfileListMessagesSummaries('customer',[newVal])
                },
                immediate: true
            }
        },
        async created(){
						this.getCustomerStatusTable()
            await this.getCustomerDetails()
            this.checkPayloadIsSuccess()
            this.getLoanAdvisoryStatus()
            if(_gHlp.isEmpty(this.sms_template_list)) {
                await this.getSmsTemplates()
            }

        },
        methods:{
            ...mapActions(useCustomerStore,['getCustomer','getCustomerStatusTable', 'generateDSR', 'generateAppFormLink'  , 'updateCustomerAdvisoryStat']),
            ...mapActions(useMessagingStore, ['getProfileListMessagesSummaries', 'getSmsTemplates']),
            ...mapActions(useNotificationStore, ['createNotification','fetchNotificationTemplate']),


          submitAppointment() {
            this.update(this.current_customer.appointment_at);
          },
            update(appointment_at) {
                this.is_loading = true;
                axios.put(
                services.customer + 'customers/' + this.$route.params.customer_id,
                { appointment_at: appointment_at },
                { headers: getHeader() }
                )
                .then(res => { 
                this.is_loading = false;
                this.notifySuccess('<b>Customer : ' + res.data.data.name + '</b> - Successfully Updated.');
                this.getCustomerDetails(this.$route.params.customer_id);
                })
                .catch(e => {
                this.is_loading = false;
                this.errorFunction(e);
                });
            },
            exportToGoogleCalendar(appointmentAt, customerName) {
            // Check if appointmentAt is not empty
            if (!this.isEmpty(appointmentAt)) {
                // Format the appointment date for the Google Calendar link
                const formattedDate = this.formatGoogleCalendarDate(appointmentAt);
                // Create the Google Calendar link
                const googleCalendarLink = this.generateGoogleCalendarLink(formattedDate, customerName);
                // Open the link in a new tab
                window.open(googleCalendarLink, '_blank');
            }
        },

        formatGoogleCalendarDate(appointmentAt) {
            const date = new Date(appointmentAt);
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');
            const seconds = date.getSeconds().toString().padStart(2, '0');

            return `${year}${month}${day}T${hours}${minutes}${seconds}`;
        },

        generateGoogleCalendarLink(formattedDate, customerName) {
            // Generate Google Calendar link with necessary details
            const googleCalendarLink = `https://www.google.com/calendar/render?action=TEMPLATE&dates=${formattedDate}/${formattedDate}&text=${customerName}&details=Your%20appointment%20description%20goes%20here.&location=Appointment%20Location&sf=true&output=xml`;

            return googleCalendarLink;
        },
            async sendGoogleReviewLink(contactNumber) 
            {
                const corporateId = this.auth_user.account_info.corporate_id;
                try {
                    const corporateId = this.auth_user.account_info.corporate_id;
                    const response = await axios.get(services.access_control + 'corporate/' + corporateId, { headers: getHeader() });
                    this.corporateDetail = response.data.data;
                    // console.log(this.corporateDetail);
                    if (contactNumber) {
                        const formattedContactNumber = contactNumber.replace(/[-()]/g, '');

                        const mobileNumber = encodeURIComponent(formattedContactNumber);
                        const reviewLink = encodeURIComponent(this.corporateDetail.review_link);
                        const whatsappLink = `https://wa.me/${mobileNumber}?text=Help%20us%20review%20at%20google%20review%20link%20here%20%3A%20${reviewLink}`;

                        window.open(whatsappLink, '_blank');
                    } else {
                        console.error('Customer mobile number is not available.');
                    }    
                } catch (error) {
                    console.error('Error fetching corporate data:', error);
                }
               
            },
            sendToWhatsApp(esign_link){
                if(!_gHlp.isEmpty(this.current_customer) && !_gHlp.isEmpty(this.current_customer.contact_no)){
                    let link = esign_link;
                    _gHlp.openNewTab('https://wa.me/'+_gHlp.formatPhoneNumber(this.current_customer.contact_no)+'?text="Fintos Customer Application Form : '+ link +'"');
                }else{
                    _gNotif.notifyError('Please fill customer contact first')
                }
            },
            async copyGoogleReviewLink() {
                try {
                    const corporateId = this.auth_user.account_info.corporate_id;
                    const response = await axios.get(services.access_control + 'corporate/' + corporateId, { headers: getHeader() });
                    this.corporateDetail = response.data.data;
                    const reviewLink = this.corporateDetail.review_link;
                    this.copyToClipboard(reviewLink);
                } catch (error) {
                    console.error('Error fetching corporate data:', error);
                }
            },

        copyApplicationFormLink(esign_link) {
          this.copyToClipboard(esign_link);
        },
        copyToClipboard(text) {
            const el = document.createElement('textarea');
            el.value = text;
            el.setAttribute('readonly', '');
            el.style.position = 'absolute';
            el.style.left = '-9999px';
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
            this._gNotif.notifySuccess('Link copied to clipboard');
        },
            updateStatus(status_id){
                if(_gHlp.isEmpty(status_id)) return false;
                let customer_id = this.current_customer.customer_id

                axios.put(services.customer + 'customer/' + customer_id + '/status/' + status_id, {}, { headers: getHeader() })
                    .then(async res => {
                        
						let sub_status = this.sub_statuses.find(sub => sub.status_id == status_id);
                        this.main_status_id = sub_status.parent_id;
						this.sub_status_id = sub_status.status_id;
											
                        this.notifySuccess('<b>Customer Status - Successfully Updated.')

                        const notificationTemplate = await this.fetchNotificationTemplate('CUSTOMER_STATUS_CHANGE')
                          if (notificationTemplate && notificationTemplate.is_active) { 
                            let message = notificationTemplate?.notif_temp_message
                            
                            const recipients = notificationTemplate.notif_temp_receiver.split(',').map(id => parseInt(id.trim(), 10));
                            let contentNotification = {
                              noti_message: "Customer #"+ this.$route.params.customer_id +" : "+message+" status:  "+sub_status.status,
                              noti_url: window.location.origin + '/customerProfileDetails/'+this.$route.params.customer_id+'?active=overview',
                              microservice_code: 'customer',
                              noti_related_type: 'customer',
                              noti_related_id: this.$route.params.customer_id
                            }
                            for (const recipient of recipients) {
                                if (!isNaN(recipient)) { // Check if recipient is a valid integer
                                    let notification = { ...contentNotification, noti_user_id: recipient };
                                    
                                    // let notification = { ...contentNotification, noti_user_id: recipients }
    
                                    this.createNotification(notification)
                                }
                            }
                            this._gNotif.notifySuccess('Successfully create notification to alert user.');
                        }
                        this.getCustomerDetails(this.$route.params.customer_id);
                    })
                    .catch(e => {
                        this.errorFunction(e)
                    })
            },
            checkPayloadIsSuccess(){
                let payload = this.$route.query.payload
                if(!payload){
                    return
                }
                let decodePayload = JSON.parse(Buffer.from(payload,'base64').toString('utf-8'));
                
                // check for report reload
                if(decodePayload.pay_paid_status){
                    if(decodePayload.pay_paid_status.toLowerCase() === 'failed'){
                        this.errorFunction(null, 'Reload Report - Failed')
                    }
                    if(decodePayload.pay_paid_status.toLowerCase() === 'paid'){
                        this.notifySuccess('Reload Report - Successfully.')
                    }
                }
                 
                // check for direct report purchase
                if(decodePayload.credit_report_status === 'completed'){
                    this.notifySuccess('Prescreening Analysis - Successfully.')
                }

                // check if failed direct purchase
                if(decodePayload.error){
                    this.errorFunction(null, 'Prescreening Analysis - Failed')
                }

                const queryParams = { ...this.$route.query };
                delete queryParams.payload;
                this.$router.replace({ query: queryParams });
            },
            async refreshDSR(){
                let message = "Are you sure you want to refresh the DSR?";
                if (confirm(message) == true) {                
                    try{
                        await this.generateDSR()
                    }catch(e){
                        this.errorFunction(e)
                    }
                }
            },
            async getCustomerDetails(){
                this.is_loading = true
                await this.getCustomer(this.$route.params.customer_id)
                if(!this.current_customer){
                    this.$router.push('/')
                    return
                }
                
								if(!_gHlp.isEmpty(this.current_customer.status.main)){
                    this.main_status_id = this.current_customer.status.main.status_id
								}
                if(!_gHlp.isEmpty(this.current_customer.loan_advisory_status.sub)){
                    this.advisory_status_id = this.current_customer.loan_advisory_status.sub.status_id
								}
								if(!_gHlp.isEmpty(this.current_customer.status.sub)){
									this.sub_status_id = this.current_customer.status.sub.status_id
									if(_gHlp.isEmpty(this.main_status_id)){
										this.main_status_id = this.current_customer.status.sub.parent_id
									}
                }

                this.is_loading = false

                if(!this.$route.query.active){
                    const query = { ...this.$route.query, active: 'overview' };
                    this.$router.push({path: this.$route.path, query});
                }
            },
            backToJointProfile(){
                const query = { active: 'overview' };
                this.$router.push({path:'/customerProfileDetails/'+this.$route.query.joint_profile, query});
            },
            getLoanAdvisoryStatus(){
                axios.get(services.lookup + 'loan_advisory_status', {headers: getHeader()})
                .then(res => {
									const applicationCode = _gAuth.appCode();
									const corporateId = _gAuth.activeCorporateId();
									if (corporateId) {
										this.loanAdvisorySubStatusList = res.data.data.filter((item) => item.group === 'sub' && item.corporate_id === corporateId);
									}
									else if (applicationCode) {
										this.loanAdvisorySubStatusList = res.data.data.filter((item) => item.group === 'sub' && item.application_code === applicationCode);
									} else {
										this.loanAdvisorySubStatusList = res.data.data.filter((item) => item.group === 'sub')
									}
                })
                .catch(e => {
                    this.errorFunction(e)
                })
            },
            async updateCustomerAdvisoryStatus(customer_id, status_id) {
              try {
                await this.updateCustomerAdvisoryStat(customer_id, status_id);
              } catch (e) {
                console.error(e);
              }
            },
            showSms(current_customer) {
                chatEventBus.$emit('show-sms-drawer', current_customer);
            },
            getAltChannel(corporate) {
                if (corporate) {
                    const corporateItem = this.corporateList.find(item => item.application_code === corporate);
                    const channel = corporateItem?.setting_json?.alt_channel; // Safely access nested properties
                    if (channel) {
                        return channel.name; // Return the channel name if it exists
                    }
                }
                return 'N/A';
            },
        },
    }
</script>